import React, { MouseEvent } from 'react';
import classNames from 'classnames';
import Spinner from 'react-bootstrap/esm/Spinner';
import './RoundButton.scss';

interface IRoundButtonProps {
  label: string;
  type: 'download'|'delete'|'confirm'|'repeat'|'remove'|'add';
  disabled?: boolean;
  loading?: boolean;
  onClick?: (event: MouseEvent) => void;
  className?: string;
}

// https://react-bootstrap.github.io/components/spinners/#variants
const spinnerVariantTypeMap = {
  'download': 'light',
  'confirm': 'light',
  'repeat': 'light',
  'delete': 'danger',
  'remove': 'danger',
  'add': 'success',
};

export const RoundButton = ({ label, type, disabled, loading, onClick, className }: IRoundButtonProps): JSX.Element => {
  const disable = disabled || loading;
  const classnames = classNames(
    'round-button',
    `round-button--type-${type}`,
    {
      'round-button--disabled': disable,
      'round-button--loading': loading,
    },
    className,
  );

  const spinnerVariant = spinnerVariantTypeMap[type] || 'light';
  return (
    <button className={classnames} aria-label={label} disabled={disable} onClick={onClick}>
      { loading && <Spinner className="round-button__spinner" animation="border" variant={spinnerVariant} size="sm"/> }
    </button>
  );
};
